@import '../../../../../../constants/spacing.module.less';

.list-container {
  overflow-y: auto;
  background-color: var(--grey-100);
  height: 100%;
  padding-top: @space-8;
}

.scan-actions {
  align-items: center;
  padding: @space-0 @space-16;
}
